import React, { useEffect, useState } from 'react';
import { Col, Form, Input, Row } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { api, endpoints } from '../../api';
import {
  BlueLayout,
  CustomButton,
  CustomGoBackButton,
  FormBlock,
  FormInput,
  FormItem,
  PagesContainerUI,
} from '../../styles/styled';
import { DocumentCategoryType } from '../DocumentCategoryPage/types';
import AddFileForm from '../NewDocumentCategory/components/AddFIleForm';
import { DocumentFileDataType } from '../NewDocumentCategory/components/AddFIleForm/types';
import { DocumentInputType } from './types';

const { TextArea } = Input;

export const NewDocumentPage = () => {
  const params = useParams();
  const [postDataState, setPostDataState] = useState<boolean>(false);

  const [documentInputState, setDocumentInput] = useState<DocumentInputType>({
    title: '',
    sort: 0,
    document_category: {
      id: params.id ? parseInt(params.id) : 1,
    },
    document_files: [],
  });
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        if (params.id) {
          const response = await api.get<DocumentCategoryType>(endpoints.getDocumentCategoryById(params.id));

          setDocumentInput({ ...documentInputState, sort: response.data.documents.length + 1 });
        }
      } catch (err) {}
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);

  useEffect(() => {
    if (postDataState) {
      (async () => {
        try {
          const newDocument = {
            ...documentInputState,
          };
          const response = await api.post(endpoints.postDocument(), newDocument);

          if (response) navigate(-1);
        } catch (err) {}
      })();
    }
    // eslint-disable-next-line
  }, [postDataState]);

  return (
    <PagesContainerUI>
      <BlueLayout>
        <CustomGoBackButton onClick={() => navigate(-1)}>{'<'}</CustomGoBackButton>
        Добавить подраздел
      </BlueLayout>
      <Form onFinish={() => setPostDataState(true)}>
        <FormBlock white>
          <Row gutter={[20, 20]}>
            <Col span={24}>
              <FormItem redstar>
                <p>Наименование</p>
                <Form.Item
                  label="Наименование"
                  name="name"
                  rules={[{ required: true, message: 'Пожалуйста, введите наименование подраздела' }]}
                >
                  <FormInput
                    value={documentInputState.title}
                    onChange={(e) => setDocumentInput({ ...documentInputState, title: e.target.value })}
                  />
                </Form.Item>
              </FormItem>
            </Col>
            <Col span={24}>
              <FormItem>
                <p>Содержание</p>
                <TextArea
                  value={documentInputState?.content}
                  onChange={(e) => setDocumentInput({ ...documentInputState, content: e.target.value })}
                />
              </FormItem>
            </Col>

            {documentInputState.document_files.map((el) => (
              <Col span={24} key={el?.id}>
                <AddFileForm
                  setForm={(idx: number, res: DocumentFileDataType) => {
                    setDocumentInput({
                      ...documentInputState,
                      document_files: documentInputState.document_files.map((el) => {
                        return el.id === idx ? res : el;
                      }),
                    });
                  }}
                  fileData={el}
                  removeForm={(idx: number) => {
                    setDocumentInput({
                      ...documentInputState,
                      document_files: documentInputState.document_files.filter((el) => el.id !== idx),
                    });
                  }}
                />
              </Col>
            ))}

            <Col span={24}>
              <CustomButton
                onClick={() =>
                  setDocumentInput({
                    ...documentInputState,
                    document_files: [
                      ...documentInputState.document_files,
                      {
                        sort: documentInputState.document_files.length + 1,
                        expire: false,
                        id: Math.floor(Math.random() * (1999 - 1) + 1),
                      },
                    ],
                  })
                }
                type="button"
                lined
                width="auto"
              >
                Добавить файл
              </CustomButton>
            </Col>
          </Row>
          <div className="to-center">
            <CustomButton>Сохранить</CustomButton>
          </div>
        </FormBlock>
      </Form>
    </PagesContainerUI>
  );
};
